import { render } from "./Show.vue?vue&type=template&id=2e3cf77a"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
script.render = render

export default script